export default __webpack_public_path__ + "static/media/logo_dark_background.678d5cda.png";